import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { LoginService, UserInfo } from '../login/login.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Bilancio, GenericResponse } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GraficiService {

  private invoiceUrl : string =  environment.url;
  //private invoiceUrl: string = AppConfig.settings.apiServer.url;

  private userInfo: UserInfo | undefined;

  constructor(private http: HttpClient) {}

  async getRiepilogoIva(){
    this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");
    return await this.fetchRiepilogoIva();
  }

  async fetchRiepilogoIva(){
    let response = await this.http.get(this.invoiceUrl + '/api/v1/users/' + this.userInfo!.user_id + "/riepilogo_iva")
      .toPromise().then((data : any) => {
        if(data.success)
            return data;
        return undefined;
      }).catch(() => {
        return undefined;
      });
    return response;
  }
}
